import { InventaireForm } from "@features/stock/components/InventaireForm";
import { ROUTES } from "@features/stock/config/constants";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/inventaires/create")({
  loader: requirePermission(PERMISSIONS.STOCK.INVENTAIRES.CREATE),
  component: CreateInventaire,
});

function CreateInventaire() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.INVENTAIRES.LIST });
  };

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Nouvel Inventaire</h1>
      <div className="bg-base-100 rounded-lg shadow p-6">
        <InventaireForm mode="create" onSuccess={handleSuccess} />
      </div>
    </div>
  );
}
